import { callApi } from './general';
import { parseFloatInput, mapObject } from '../helpers/input';

export const fertilizerTypes = {
    liquid: 'Liquid',
    solid: 'Solid',
    solidWithLiquidCalcium: 'Liquid_Calcium',
};

/*
{
    "settings": {
        "AB": false,
        "ConcentrateFactor": 100,
        "DefaultFerts": "Liquid",
        "TankSize_m3": 100
    },
    "priority": ["Cl", "Ca", "NH4", "P", "S", "Mg", "NO3", "Si", "K", "Fe", "Mn", "Zn", "B", "Cu", "Mo"],
    "recipe": {
        "EC": 3,
        "NH4": 1,
        "K": 11,
        "Na": 0,
        "Ca": 6.5,
        "Mg": 2.5,
        "NO3": 22.3,
        "Cl": 0,
        "SO4": 2.9,
        "H2PO4": 1.9,
        "HCO3": 0,
        "Fe": 20,
        "Mn": 10,
        "Zn": 7,
        "B": 12,
        "Cu": 0.75,
        "Mo": 0.75
    }
}
*/
export const runFertilizerModel = (key, settings, recipe) => {
    return new Promise((resolve, reject) => {
        const {
            priority,
            fertilizerType,
            tankSize,
            concentrateFactor,
            abTanks,
        } = settings;
        const modelParameters = {
            settings: {
                AB: abTanks,
                ConcentrateFactor: parseFloatInput(concentrateFactor),
                DefaultFerts: fertilizerType,
                TankSize_m3: parseFloatInput(tankSize),
            },
            priority,
            recipe: mapObject(recipe, parseFloatInput),
        };
        callApi('fert_convert', key, {}, modelParameters)
            .then((output) => {
                resolve(output);
            })
            .catch((err) => reject(err));
    });
};

export const runBalanceAcidBase = (key, modelOutputFertilizer) => {
    return new Promise((resolve, reject) => {
        const modelParameters = {};
        callApi('acid_base_balance', key, {}, { data: modelOutputFertilizer })
            .then((output) => {
                resolve(output);
            })
            .catch((err) => reject(err));
    });
};
